export const PRIMARY = {
  DARKEST: '#00263E',
  DARKER: '#043452',
  DARK: '#084367',
  DEFAULT: '#0B4A72',
  LIGHT: '#DCE9EF',
  LIGHTER: '#EEF4F9',
  LIGHTEST: '#F6F9FC',
} as const;
